<template>
  <v-autocomplete
    v-model="model"
    :items="searchResults"
    :loading="isLoading"
    :search-input.sync="search"
    hide-no-data
    hide-selected
    item-text="label"
    item-value="id"
    rounded
    autofocus
    placeholder="Suchbegriff eingeben"
    prepend-icon="mdi-magnify"
    append-icon=""
    return-object
  >
    <template v-slot:item="data">
      <v-list-item-content>
        <v-list-item-title v-html="data.item.label"></v-list-item-title>
        <v-list-item-subtitle>
          {{ data.item.type === 'shaft' ? 'Schacht' : 'Baustelle' }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </template>
  </v-autocomplete>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'SearchBar',
  components: {},
  data: () => ({
    visible: true,
    descriptionLimit: 60,
    entries: [],
    isLoading: false,
    model: null,
    search: undefined,
  }),
  computed: {
    ...mapGetters(['searchResults']),
  },

  watch: {
    async search(val) {
      await this.searchSitesAndShafts(val);
    },
    model() {
      this.$emit('searchFinished', this.model);
      if (this.model.type === 'shaft')
        this.$router.push('/schacht/' + this.model.id);
      if (this.model.type === 'site')
        this.$router.push('/baustellen/' + this.model.id);
    },
  },

  methods: {
    ...mapActions(['searchSitesAndShafts']),
  },
};
</script>

<style scoped>
.floating-search-bar {
  height: 56px;
  position: absolute;
  top: 50px;
  z-index: 1000;
  width: 100%;
}

.floating-search-bar >>> .v-toolbar__content,
.floating-search-bar >>> .v-toolbar__extension {
  border-bottom: 1px #e9e9e9 solid;
}

.search-bar-dialog {
  width: 100%;
  margin: 0px !important;
}
</style>
